// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2HaUB","modalForm":"UpgradeEpcsModal_modalForm__rDxIm","modalFooter":"UpgradeEpcsModal_modalFooter__4IHFE"};